import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.QBooksLineItemsSection', {
    amountColumnName: 'Amount {currency}',
    billableColumnName: 'Billable',
    billableColumnTooltip: 'This line is billable',
    classColumnName: 'Class',
    customerColumnName: 'Customer',
    descriptionColumnName: 'Description',
    discountText: 'Discount:',
    discountTextPercent: 'Discount ({discount}%):',
    itemColumnName: 'Product/Service',
    linkedColumnName: 'Linked',
    matching: 'Link',
    qtyColumnName: 'Qty',
    sectionHeaderText: 'Item Details',
    serviceDateColumnName: 'Service date',
    shippingText: 'Shipping:',
    subTotalText: 'Subtotal:',
    taxColumnName: 'Tax',
    taxComponentTextTaxExclusive: 'Tax {percent}% on {taxableAmount}:',
    taxComponentTextTaxInclusive: 'Includes Tax {percent}% on {taxableAmount}:',
    taxTypeTextTaxExclusive: 'Amounts are Tax Exclusive',
    taxTypeTextTaxInclusive: 'Amounts are Tax Inclusive',
    taxableColumnName: 'Tax',
    taxableColumnTooltip: 'This line is taxable',
    totalCompanyCurrencyText: 'Total ({companyCurrency}):',
    totalRequestCurrencyText: 'Total ({currency}):',
    totalText: 'Total ({currency}):',
    unitPriceColumnName: 'Rate',
});
